<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Ticket</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="items=[]; getTickets(cboStatus, txtEmail, txtTitle, txtUserId, txtTicketId, txtMinTicketDate, txtMaxTicketDate, cboSort); rightDrawer=false;"
      >
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" lazy-validation @submit.prevent="">
              <v-text-field
                v-model="txtTitle"
                label="Title"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtEmail"
                label="Email"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtUserId"
                label="User ID"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtTicketId"
                label="Ticket ID"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboStatus"
                :items="statuses"
                label="Status"
              ></v-select>
              <v-menu
                ref="dtMinTicketDate"
                :close-on-content-click="false"
                v-model="dtMinTicketDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMinTicketDate"
                  label="Min Date"
                ></v-text-field>
                <v-date-picker v-model="txtMinTicketDate" no-title @input="dtMinTicketDate = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="dtMaxTicketDate"
                :close-on-content-click="false"
                v-model="dtMaxTicketDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMaxTicketDate"
                  label="Max Date"
                ></v-text-field>
                <v-date-picker v-model="txtMaxTicketDate" no-title @input="dtMaxTicketDate = false"></v-date-picker>
              </v-menu>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="title"
                item-value="key"
                label="Sorting"
              ></v-select>
              <v-btn
                @click="clickFilter()"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter(); getTickets(cboStatus, txtEmail, txtTitle, txtUserId, txtTicketId, txtMinTicketDate, txtMaxTicketDate, cboSort); rightDrawer=false;">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-tabs
        color="grey darken-4"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs"
          :key="index"
          :to="'/tickets/' + item.key"
        >
          <v-badge color="red" small class="ml-3 mr-4" v-if="item.key === 'pending'">
            <template v-slot:badge v-if="profile.pendingTicketNewMessageCount > 0">
              <span>{{ profile.pendingTicketNewMessageCount }}</span>
            </template>
            <span>{{ item.title }} ({{ profile.pendingTicketCount }})</span>
          </v-badge>
          <v-badge color="red" small class="ml-3 mr-4" v-if="item.key === 'replied'">
            <template v-slot:badge v-if="profile.repliedTicketNewMessageCount > 0">
              <span>{{ profile.repliedTicketNewMessageCount }}</span>
            </template>
            <span>{{ item.title }} ({{ profile.repliedTicketCount }})</span>
          </v-badge>
          <v-badge color="red" small class="ml-3 mr-4" v-else-if="item.key === 'others'">
            <template v-slot:badge v-if="profile.otherTicketNewMessageCount > 0">
              <span>{{ profile.otherTicketNewMessageCount }}</span>
            </template>
            <span>{{ item.title }}</span>
          </v-badge>
          <v-badge color="red" small class="ml-3 mr-4" v-else-if="item.key === 'closed'">
            <template v-slot:badge v-if="profile.closedTicketNewMessageCount > 0">
              <span>{{ profile.closedTicketNewMessageCount }}</span>
            </template>
            <span>{{ item.title }}</span>
          </v-badge>
          <span v-else-if="item.key === 'all'">{{ item.title }}</span>
        </v-tab>
      </v-tabs>
      <v-list two-line>
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.ticketId"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action class="text-xs-center">
              <v-list-tile-action-text>
                <div v-if="item.status === 'open' && item.isPrimaryHandler === 1">
                  <div><v-icon medium color="orange">perm_identity</v-icon></div>
                  <div class="caption">MINE</div>
                </div>
                <div v-else-if="item.status === 'open'">
                  <div><v-icon medium color="white">hourglass_empty</v-icon></div>
                  <div class="caption">OPEN</div>
                </div>
                <div v-else-if="item.status === 'closed'">
                  <div><v-icon medium color="grey darken-1">https</v-icon></div>
                  <div class="caption">CLOSED</div>
                </div>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <router-link :class="(item.isNewMessage === 1 ? 'font-weight-bold orange--text text--lighten-2' : 'font-weight-light grey--text text--lighten-1')" :to="'/ticket/' + item.ticketId">{{ item.title | truncate(110) }}</router-link>
                <span v-if="item.isNewMessage === 1" class="caption red pa-1 ml-2">NEW</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="caption">By {{ (item.createdByUserStoreId !== '' ? item.createdByUserStoreName + ' (' + item.createdByUserStoreType + ')' : (item.createdByUserId !== '' ? item.createdByUserLoginEmail : item.createdByAdminName + ' (admin)')) }} on {{ item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }} - <strong>{{ item.ticketId }}</strong></v-list-tile-sub-title>
              <v-list-tile-sub-title>
                To:
                <span v-for="user in item.users" :key="user.userId">
                  <v-chip small v-if="user.role === 'buyer'">{{ user.loginEmail }} (buyer)</v-chip>
                  <v-chip small v-else-if="user.role === 'seller' && user.isPrimaryHandler === 1">
                    <v-avatar>
                      <v-icon color="orange" class="ml-2">store</v-icon>
                    </v-avatar>
                    {{ user.storeName }} ({{ user.storeType }})
                  </v-chip>
                </span>
                <span v-for="admin in item.admins" :key="admin.adminId">
                  <v-chip small v-if="admin.isCreator === 0">
                    <v-avatar v-if="admin.isPrimaryHandler === 1">
                      <v-icon color="orange" class="ml-1">account_circle</v-icon>
                    </v-avatar>
                    {{ admin.name }} (admin)
                  </v-chip>
                </span>
                <span v-for="email in item.emails" :key="email.email">
                  <v-chip small>
                    <v-avatar>
                      <v-icon small class="ml-2">email</v-icon>
                    </v-avatar>
                    {{ email.email }}
                  </v-chip>
                </span>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>Last reply: {{ (item.lastReplyDateTime !== '' ? item.lastReplyDateTimeDisplay : item.createdDateTimeDisplay) }}</v-list-tile-action-text>
              <div class="body-2 grey--text text--lighten-1">{{ item.ticketCategoryName }}</div>
              <div v-if="item.status === 'open'">
                <div v-if="item.replyDatelineDateTime && item.pendingReplyFrom === 'admin'" :class="'font-weight-bold' + (item.lateReplyInMinutes >= -360 && item.lateReplyInMinutes <= 0 ? ' orange--text blink-text' : (item.lateReplyInMinutes >0 ? ' red--text blink-text' : ''))">
                  Must reply {{ item.replyDatelineDateTimeDisplay }}
                </div>
                <div v-else class="caption grey--text">
                  Pending for <span :class="(item.pendingReplyFrom === 'admin' || item.pendingReplyFrom === 'seller' ? 'font-weight-bold orange--text' : '')">{{ item.pendingReplyFrom }}</span>
                </div>
              </div>
            </v-list-tile-action>

            <v-btn icon class="ml-3" color="primary" :to="'/ticket/' + item.ticketId">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No ticket yet
            </div>
          </v-flex>
        </template>
      </v-list>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} tickets
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import moment from 'moment'
import axios from 'axios'
import router from '../router'
import { EventBus } from '../main'

export default {
  props: {
    status: {
      type: String,
      default: 'pending',
      required: false
    }
  },
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      autoloadInterval: null,
      loading: false,
      canReadTickets: false,
      frmValid: true,
      txtEmail: '',
      txtTitle: '',
      txtUserId: '',
      txtTicketId: '',
      dtMinTicketDate: false,
      dtMaxTicketDate: false,
      txtMinTicketDate: '',
      txtMaxTicketDate: '',
      cboStatus: '',
      statuses: ['all', 'pending', 'replied', 'others', 'closed'],
      cboSort: '',
      sorts: [
        {
          key: 'createdDateTime:desc',
          title: 'Latest'
        },
        {
          key: 'createdDateTime:asc',
          title: 'From beginning'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      tabs: [
        {
          key: 'pending',
          title: 'Pending'
        },
        {
          key: 'replied',
          title: 'Replied'
        },
        {
          key: 'others',
          title: 'Others'
        },
        {
          key: 'closed',
          title: 'Closed'
        },
        {
          key: 'all',
          title: 'All'
        }
      ]
    }
  },
  created () {
    var _this = this
    EventBus.$on('profileUpdated', profile => {
      _this.profile = profile
    })
    EventBus.$on('logout', function () {
      clearInterval(_this.autoloadInterval)
    })
  },
  mounted () {
    this.openDrawerForDesktop()

    // init
    this.clearFilter()
    this.txtEmail = this.$route.query.email || ''
    this.txtTitle = this.$route.query.name || ''
    this.txtUserId = this.$route.query.user_id || ''
    this.txtTicketId = this.$route.query.ticket_id || ''
    this.txtMinTicketDate = this.$route.query.min_date || ''
    this.txtMaxTicketDate = this.$route.query.max_date || ''
    this.cboSort = this.$route.query.sort || ''
    this.$emit('disableProfileRefresh')

    if (this.checkPermission(this.profile, 'PEM-TICKET', 'read')) {
      this.canReadTickets = true
    }

    this.getTickets(this.cboStatus, this.txtEmail, this.txtTitle, this.txtUserId, this.txtTicketId, this.txtMinTicketDate, this.txtMaxTicketDate, this.cboSort)

    var _this = this
    _this.autoloadInterval = setInterval(function () {
      _this.getTickets(_this.cboStatus, _this.txtEmail, _this.txtTitle, _this.txtUserId, _this.txtTicketId, _this.txtMinTicketDate, _this.txtMaxTicketDate, _this.cboSort)
    }, (1 * 60 * 1000))
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getTickets(this.cboStatus, this.txtEmail, this.txtTitle, this.txtUserId, this.txtTicketId, this.txtMinTicketDate, this.txtMaxTicketDate, this.cboSort, (val - 1) * this.listLimit)
    }
  },
  methods: {
    clickFilter: function () {
      this.items = []
      this.rightDrawer = false
      if (this.cboStatus === this.status) {
        this.getTickets(this.cboStatus, this.txtEmail, this.txtTitle, this.txtUserId, this.txtTicketId, this.txtMinTicketDate, this.txtMaxTicketDate, this.cboSort)
      } else {
        router.push('/tickets/' + this.cboStatus + '?ticket_id=' + this.txtTicketId + '&title=' + this.txtTitle + '&user_id=' + this.txtUserId + '&email=' + this.txtEmail + '&min_date=' + this.txtMinTicketDate + '&max_date=' + this.txtMaxTicketDate + '&sort=' + this.cboSort)
      }
    },
    getTickets: function (status = '', email = '', title = '', userId = '', ticketId = '', minCreatedDate = '', maxCreatedDate = '', sort = '', offset = 0) {
      var _this = this
      var params = ''
      var endpoint = ''
      switch (status) {
        case 'pending':
          endpoint = 'tickets/me'
          params = 'status=open&pending_reply_from=admin'
          break
        case 'replied':
          endpoint = 'tickets/me'
          params = 'status=open&not_pending_reply_from=admin'
          break
        case 'others':
          endpoint = 'tickets'
          params = 'status=open&not_for_primary_admin_id=' + _this.profile.adminId
          break
        case 'closed':
          endpoint = 'tickets'
          params = 'status=closed'
          break
        case 'all':
          endpoint = 'tickets'
          params = ''
          break
      }

      if (minCreatedDate !== '') {
        minCreatedDate = moment.utc(minCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }
      if (maxCreatedDate !== '') {
        maxCreatedDate = moment.utc(maxCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }

      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        params += '&ticket_id=' + ticketId + '&title=' + title + '&email=' + email + '&for_user_id=' + userId + '&min_created_datetime=' + minCreatedDate + '&max_created_datetime=' + maxCreatedDate + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/' + endpoint + '?' + params)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              for (var i in resp.data.data) {
                resp.data.data[i].createdDateTimeDisplay = moment(resp.data.data[i].createdDateTime, _this.iso8601Format()).fromNow()
                resp.data.data[i].lastVisibleReplyDateTimeDisplay = moment(resp.data.data[i].lastVisibleReplyDateTime, _this.iso8601Format()).fromNow()
                resp.data.data[i].lastReplyDateTimeDisplay = moment(resp.data.data[i].lastReplyDateTime, _this.iso8601Format()).fromNow()
                resp.data.data[i].replyDatelineDateTimeDisplay = moment(resp.data.data[i].replyDatelineDateTime, _this.iso8601Format()).fromNow()
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
              _this.$store.dispatch('UPDATE_PROFILE')
            } else {
              console.log('unable to load tickets: ' + resp.data.message)
            }
            _this.isLoadingItems = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                clearInterval(_this.autoloadInterval)
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                clearInterval(_this.autoloadInterval)
                _this.showAlert(error)
              }
              _this.loading = false
              _this.isLoadingItems = false
            }
          })
      }
    },
    clearFilter () {
      this.cboStatus = this.status
      if (typeof this.cboStatus === 'undefined' || this.cboStatus === '') {
        this.cboStatus = 'pending'
      }
      this.txtEmail = ''
      this.txtTitle = ''
      this.txtUserId = ''
      this.txtTicketId = ''
      this.txtMinTicketDate = ''
      this.txtMaxTicketDate = ''
      this.cboSort = ''
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
